import React from "react";
import { Box, Container } from "@mui/material";
import PlaceOrderGuide from "./PlaceOrderGuide";
import InformationCards from "./InformationCards";
import Footer from "./Footer";

const BerelianFooter = () => {
  return (
    <Box sx={{ maxWidth: 1500, margin: "0 auto" }}>
      <PlaceOrderGuide />
      <InformationCards />
      <Footer />
    </Box>
  );
};

export default BerelianFooter;
